module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-form-wrap-row spacing-height input-box",
    class: _vm.inputStyleClass
  }, [_c('div', {
    staticClass: "input-label"
  }, [(_vm.required) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('el-input-number', {
    staticClass: "input-form",
    staticStyle: {
      "text-align": "left"
    },
    style: (_vm.customStyle),
    attrs: {
      "id": "num-align",
      "value": _vm.value,
      "controls-position": "right",
      "min": 0,
      "size": "small",
      "disabled": _vm.isEditServOrder == '1',
      "step": _vm.step
    },
    on: {
      "input": _vm.handleInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "suffix-text"
  }, [_vm._v(_vm._s(_vm.suffixText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-513d4240","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/orderCreate/InputNumberField.vue
// module id = 645
// module chunks = 0